import axios from '@/libs/api.request'

export const getMyTodos = () => {
  return axios.request({
    url: 'tasks/my-todos',
    method: 'get'
  })
}

export const completeTodo = (id) => {
  return axios.request({
    url: `tasks/todos/${id}/complete`,
    method: 'POST'
  })
}

export const updateTodo = (data, id) => {
  return axios.request({
    url: `tasks/todos/${id}`,
    method: 'PUT',
    data: data
  })
}
